import { SortStrategy } from "@/views/AskShop/type";
import { postAction } from "./request";
import { isProd } from "@/utils/env";

type BaseParams = {
  deviceCode: string;
  sessionId: number;
  requestId: number;
};
const baseURL = isProd()
  ? "https://rec-ai-cus.voghion.com/rec-prompt"
  : "https://rec-ai-cus-gray.voghion.com/rec-gray-prompt";

export async function sendAIMessage(params = {}) {
  return fetch(`${baseURL}/see/customer/shopping-guide`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });
}

/**
 * 分流AI客服
 * @param {*} params
 * @returns
 */
export async function diversionAiCustomer() {
  return postAction("/cms/message-box/diversionAiCustomer");
}

export async function getSessionId(params: { deviceCode: string }) {
  return fetch(`${baseURL}/ai/shopping/guide/sessionId`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });
}

interface GetRecTopicParams extends BaseParams {
  countryCode: string;
  language: string;
  itemIds: number[];
}

/**
 * 获取推荐话题
 * @param {*} params
 * @returns
 */
export async function getRecTopic(params: GetRecTopicParams) {
  return fetch(`${baseURL}/ai/shopping/guide/items/rec/topic`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });
}

interface GetRecommendGoodsParams extends BaseParams {
  stageId: number;
  pageIndex: number;
  pageSize: number;
  sortStrategy: SortStrategy;
}

/**
 * 推荐商品查询
 * @param {*} params
 * @returns
 */
export async function getRecommendGoods(params: GetRecommendGoodsParams) {
  return fetch(`${baseURL}/ai/shopping/guide/historyRecallItems`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });
}

export enum OptType {
  ReGenerate = "REGENERATE",
  Like = "LIKE",
  DisLike = "DISLIKE",
  LikeCancel = "LIKE_CANCEL",
  DisLikeCancel = "DISLIKE_CANCEL",
}

/**
 * 推荐商品查询
 * @param {*} params
 * @returns
 */
export async function messageOpt(params: BaseParams & { opt: OptType }) {
  return fetch(`${baseURL}/ai/shopping/guide/opt`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });
}
